import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder } from '../tokens';

export const styledMuiTabs = (theme: Theme): BackstageOverrides['MuiTabs'] => ({
  root: {
    minHeight: theme.spacing(6.75),
    width: '100%',
  },
  flexContainer: {
    alignItems: 'flex-end',
    borderBottom: `1px solid ${getSurfaceBorder(theme)}`,
    gap: theme.spacing(0.75),
    padding: theme.spacing(2, 2, 0),
  },
  indicator: {
    borderRadius: 999,
    height: '3px',
  },
});
